/**
 * Initialize quantity and length inputs
 * Exported so it can be called after Sprig loads new content
 */
export function initQuantityInputs() {
    console.log('[quantity-input] Initializing quantity inputs...');

    const quantityInputs = document.querySelectorAll('[data-js-quantity]')
    const lengthInputs = document.querySelectorAll('[data-js-length]')

    console.log('[quantity-input] Found:', quantityInputs.length, 'quantity inputs,', lengthInputs.length, 'length inputs');

    quantityInputs.forEach(quantityInput => {
        const minus = quantityInput.querySelector('[data-minus]')
        const plus = quantityInput.querySelector('[data-plus]')
        const input = quantityInput.querySelector('input')
        const step = Number(input.getAttribute('step') ?? 1)
        const minimum = Number(input.getAttribute('min') ?? 1)

        // Remove existing listeners to prevent duplicates
        const newPlus = plus.cloneNode(true);
        const newMinus = minus.cloneNode(true);
        plus.parentNode.replaceChild(newPlus, plus);
        minus.parentNode.replaceChild(newMinus, minus);

        newPlus.addEventListener('click', (event) => {
            event.preventDefault()
            input.value = String(Number(input.value) + (step - (input.value % step)))
            input.dispatchEvent(new Event('change'))
        })

        newMinus.addEventListener('click', (event) => {
            event.preventDefault()
            input.value = String(Math.max(minimum, Number(input.value) - (input.value % step ? input.value % step : step) ))
            input.dispatchEvent(new Event('change'))
        })
    })

    lengthInputs.forEach(lengthInput => {
        const minus = lengthInput.querySelector('[data-minus]')
        const plus = lengthInput.querySelector('[data-plus]')
        const input = lengthInput.querySelector('input')
        const step = Number(input.getAttribute('step') ?? 1)
        const minimum = Number(input.getAttribute('min') ?? 1)
        const maxAttr = input.getAttribute('max')
        const maximum = maxAttr !== null && maxAttr !== '' ? Number(maxAttr) : null

        // Remove existing listeners to prevent duplicates
        const newPlus = plus.cloneNode(true);
        const newMinus = minus.cloneNode(true);
        plus.parentNode.replaceChild(newPlus, plus);
        minus.parentNode.replaceChild(newMinus, minus);

        newPlus.addEventListener('click', (event) => {
            event.preventDefault()
            const next = Number(input.value) + (step - (input.value % step))
            input.value = String(maximum !== null ? Math.min(maximum, next) : next)
            input.dispatchEvent(new Event('change'))
        })

        newMinus.addEventListener('click', (event) => {
            event.preventDefault()
            input.value = String(Math.max(minimum, Number(input.value) - (input.value % step ? input.value % step : step) ))
            input.dispatchEvent(new Event('change'))
        })

        // Clamp typed/pasted values on blur or change so users can't bypass
        // the max by editing the input directly.
        input.addEventListener('change', () => {
            let value = Number(input.value)
            if (Number.isNaN(value)) return
            if (value < minimum) value = minimum
            if (maximum !== null && value > maximum) value = maximum
            if (String(value) !== input.value) {
                input.value = String(value)
            }
        })
    })
}

// Initialize on page load
initQuantityInputs();
